interface ReportTransitionDetail {
  direction: "forward" | "back";
}

let pendingDirection: ReportTransitionDetail["direction"] | undefined;

window.addEventListener("phx:report-transition", (event) => {
  pendingDirection = (event as CustomEvent<ReportTransitionDetail>).detail.direction;
});

const MOMENTUM_SETTLE_MS = 100;

const prefersReducedMotion = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const releaseScroll = () => document.documentElement.style.removeProperty("overflow");

export const onDocumentPatch = (start: () => void) => {
  const direction = pendingDirection;
  pendingDirection = undefined;

  if (!direction) {
    start();
    return;
  }

  const root = document.documentElement;

  const update = () => {
    start();
    root.style.overflow = "hidden";
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  if (!("startViewTransition" in document) || prefersReducedMotion()) {
    update();
    setTimeout(releaseScroll, MOMENTUM_SETTLE_MS);
    return;
  }

  root.dataset.reportDirection = direction;

  void document.startViewTransition(update).finished.then(() => {
    delete root.dataset.reportDirection;
    releaseScroll();
  });
};
